module.exports = __webpack_public_path__ + "static/media/Cotisations1.2ca225df.pdf";